'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { calculatedPriceSelector } from '../../selectors/PricingSelectors';
import { suiteProductConfigurationsSelector } from '../../selectors/ProductConfigsSelectors';
import ProductLevelSelectionButton from './ProductLevelSelectionButton';
import { CRM_SUITE_PRODUCTS } from 'pricing-pages-lib/utils/productsUtils';
import { ownsCrmSuiteProductLevel } from '../../selectors/ProductInventorySelectors';

const SuiteProductLevelSelectionButtonContainer = ({
  productLevel,
  onClick,
  selected
}) => {
  const crmSuitePrice = useSelector(state => {
    const crmSuiteProductConfigurations = suiteProductConfigurationsSelector(state, {
      productLevel
    });
    const priceObject = calculatedPriceSelector(state, {
      productConfigurations: crmSuiteProductConfigurations
    });
    return priceObject.monthly.calculatedPrice;
  });
  const isCurrentPlan = useSelector(state => ownsCrmSuiteProductLevel(state, {
    productLevel
  }));
  return /*#__PURE__*/_jsx(ProductLevelSelectionButton, {
    id: `suite-calculator-${productLevel}-button`,
    productLevel: productLevel,
    price: crmSuitePrice,
    onClick: onClick,
    selected: selected,
    isCurrentPlan: isCurrentPlan
  });
};

const SuiteProductLevelPicker = ({
  setProductLevel,
  selectedProductLevel
}) => {
  return /*#__PURE__*/_jsx("div", {
    className: "flex-row",
    children: Object.keys(CRM_SUITE_PRODUCTS).map(productLevel => /*#__PURE__*/_jsx(SuiteProductLevelSelectionButtonContainer, {
      productLevel: productLevel,
      onClick: () => setProductLevel(productLevel),
      selected: selectedProductLevel === productLevel
    }, productLevel))
  });
};

export default SuiteProductLevelPicker;